import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, Icon } from 'antd';
import parse from 'html-react-parser';
import { stripBody } from './../utils';
import { flexCenterRight } from './../theme';

function EventBodyDisplay({ data }) {
  const ref = useRef(null);
  const [isShow, setIsShow] = useState(false);
  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    if (ref.current.clientHeight > 200) {
      setIsShow(true);
    }
  }, []);

  return (
    <div ref={ref}>
      {
        isShow ? (
          <>
          <div style={flexCenterRight}>
            <div 
              onClick={() => {
                setIsExpand(!isExpand);
              }}
              style={{
              cursor: 'pointer',
              marginRight: '1px'
              }}>
                <Tooltip placement="left" title={isExpand ? 'Collapse Details' : 'Expand Details'}>
                  {
                    isExpand ? (
                      <Icon type="minus"/>
                    ) : (
                      <Icon type="plus"/>
                    )
                  }
                </Tooltip>
            </div>
          </div>
          <div style={!isExpand ? {maxHeight: '200px',overflow: "auto"} : null}>
            {parse(stripBody(data))}
          </div>
          </>
        ) : (
         <div>
           {parse(stripBody(data))}
         </div> 
        )
      }
    </div>
  );
}

export default EventBodyDisplay;